import axios from "axios"
import React from "react"
import { connect } from "react-redux"
import { setDestroy, setHideSoftphone } from "../actions/softphone"
import * as actions from "../actions/websocket"
import WebRTCChecker from "../checks/WebRTC"
import SoftphoneWrapper from "./SoftphoneWrapper"

class SoftphoneComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
        }
        this.messageCallback = this.onMessage.bind(this)
    }

    componentDidUpdate = (prevProps, prevState) => {
        // if(prevProps.apiKey !== this.props.apiKey) {
        //   this.props.dispatch(actions.connect(this.props.apiKey));
        // }
    }

    componentDidMount = () => {
        if (this.props.apiKey) {
            this.props.dispatch(actions.subscribe(this.messageCallback, undefined))
            this.props.dispatch(actions.connect(this.props.apiKey))
            this.props.dispatch(setDestroy(false))
        }
    }

    componentWillUnmount = () => {
        this.props.dispatch(actions.unsubscribe(this.messageCallback, undefined))
        this.props.dispatch(actions.disconnect())
    }

    onMessage = (conn, cmd, data) => {
        if (cmd === "error" || cmd === "originate_error") {
            this.props.eventHandler.onError(data)
        }
    }

    render() {
        if (this.state.loading) return null
        return (
            <WebRTCChecker enableAutoTests={this.props.enableAutoTests}>
                <SoftphoneWrapper eventHandler={this.props.eventHandler}/>
            </WebRTCChecker>
        )
    }
}

const mapStateToProps = state => {
    return {
        apiKey: state.softphone?.get("apiKey"),
    }
}

export default connect(mapStateToProps)(SoftphoneComponent)
